module.exports = __webpack_public_path__ + "img/hello_card_pay.ebf302ed.png";